module.exports = __webpack_public_path__ + "img/wugonghai.1204649f.png";